export const heroData = {
  title: "鬼父在线",
  subtitle: "官方入口 · 正版高清资源直达",
  description: "为您提供最全面的资源导航与观看指引，整合优质内容入口，快速找到所需资源。收藏本站，获取最新更新动态与相关推荐。",
  ctaPrimary: "立即观看",
  ctaSecondary: "了解更多",
};

export const statsData = [
  { label: "高清资源", value: "10,000+", icon: "ri-movie-2-line" },
  { label: "每日更新", value: "50+", icon: "ri-refresh-line" },
  { label: "活跃用户", value: "500万+", icon: "ri-user-star-line" },
  { label: "涵盖分类", value: "20+", icon: "ri-stack-line" },
];

export const featuresData = [
  {
    icon: "ri-vidicon-line",
    title: "蓝光高清画质",
    description: "全部资源均为1080P及以上高清画质，支持4K超清播放，带来极致观影体验。",
  },
  {
    icon: "ri-speed-up-line",
    title: "极速加载播放",
    description: "采用全球CDN加速节点，资源加载速度极快，告别卡顿与缓冲等待。",
  },
  {
    icon: "ri-shield-check-line",
    title: "正版安全可靠",
    description: "官方正版授权资源，无毒无广告，安全可靠，放心观看每一部作品。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端同步观看",
    description: "支持PC、平板、手机多端同步，随时随地畅享精彩内容，进度云端同步。",
  },
];

export const testimonialsData = [
  {
    name: "动漫迷小王",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20young%20male%20character%20portrait%20avatar%20with%20warm%20smile%2C%20simple%20soft%20colored%20background%2C%20illustration%20style%2C%20clean%20modern%20design%2C%20friendly%20expression%2C%20Japanese%20anime%20inspired%20art%20style%20with%20soft%20lighting%20and%20gentle%20colors&width=80&height=80&seq=avatar-01&orientation=squarish",
    comment: "鬼父在线真的是我见过资源最全的平台！更新速度超快，画质也很棒，强烈推荐给所有动漫爱好者！",
    rating: 5,
  },
  {
    name: "资深宅男老李",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20male%20character%20portrait%20with%20glasses%2C%20intellectual%20look%2C%20simple%20neutral%20background%2C%20illustration%20art%20style%2C%20clean%20Japanese%20anime%20inspired%20design%20with%20warm%20gentle%20tones&width=80&height=80&seq=avatar-02&orientation=squarish",
    comment: "用了三年了，从最初的几十部资源到现在上万部，鬼父在线的成长有目共睹。1080P高清看着就是爽！",
    rating: 5,
  },
  {
    name: "追番少女阿琳",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20young%20female%20character%20portrait%20avatar%20with%20pink%20hair%2C%20cheerful%20expression%2C%20simple%20pastel%20background%2C%20illustration%20art%2C%20Japanese%20anime%20inspired%20design%20with%20soft%20warm%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish",
    comment: "分类导航做得特别清晰，找番超方便！界面也很简洁好看，手机端和电脑端体验都很流畅。",
    rating: 5,
  },
];

export const faqData = [
  {
    question: "鬼父在线是什么平台？",
    answer: "鬼父在线是一个专注于动漫资源的导航与观看平台，整合了海量高清动漫资源入口，为用户提供便捷、安全、高质量的观看体验。平台所有资源均为正版高清内容，支持1080P至4K画质播放。",
  },
  {
    question: "鬼父在线资源是否免费？",
    answer: "鬼父在线提供丰富的免费资源供用户体验，部分独家资源和最新更新内容可能需要会员权限。我们致力于在保证资源质量的同时，让更多用户能够享受到优质的动漫内容。",
  },
  {
    question: "如何找到鬼父在线的最新资源？",
    answer: "您可以通过首页的「最新更新」板块查看每日新增资源，也可以订阅我们的更新通知。建议收藏本站或关注我们的社交媒体账号，第一时间获取鬼父在线的最新动态与资源推荐。",
  },
  {
    question: "鬼父在线的画质怎么样？",
    answer: "鬼父在线所有资源均提供1080P高清画质，部分热门资源支持4K超清播放。我们采用先进的视频编码技术，在保证画质的同时优化加载速度，让您享受流畅的高清观影体验。",
  },
  {
    question: "支持哪些设备观看？",
    answer: "鬼父在线支持PC电脑、平板、手机等多种设备观看，无需下载任何APP或插件。网页端直接打开即可播放，播放进度可云端同步，随时随地切换设备继续观看。",
  },
  {
    question: "如何联系鬼父在线客服？",
    answer: "您可以通过「关于我们」页面的联系方式与我们取得联系，包括在线客服、电子邮箱和社交媒体渠道。我们的客服团队会在24小时内回复您的咨询。",
  },
];

export const ctaData = {
  title: "立即开启高清观影之旅",
  description: "加入鬼父在线，畅享10000+高清资源，每日更新，精彩不断！",
  buttonText: "立即进入",
};